import React, { Component } from "react";

function paramSeparator(url) {
  return url.indexOf("?") > 0 ? "&" : "?";
}

class PaginationLink extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if (this.props.changeUrl) {
      e.preventDefault();
      this.props.changeUrl(
        e.target.href,
        e.target.getAttribute("data-pull-url")
      );
    }
  }

  render() {
    let url = this.props.pagination.base_url;
    let pullUrl = this.props.pagination.base_pull_url;

    if (this.props.page > 1) {
      url += `${paramSeparator(url)}page=${this.props.page}`;
      pullUrl += `${paramSeparator(pullUrl)}page=${this.props.page}`;
    }

    let content;
    if (this.props.page === this.props.pagination.current_page) {
      content = <strong>{this.props.text}</strong>;
    } else {
      content = (
        <a
          href={url}
          data-pull-url={pullUrl}
          onClick={(e) => this.handleClick(e)}
        >
          {this.props.text}
        </a>
      );
    }

    return <li>{content}</li>;
  }
}
export default PaginationLink;
